<template>
	<v-container 
			class="customVContainer"
			:style="$_forgetPassword_stylePageContainerStyle()"
			fluid>
		<template v-if="initialized_">
			<v-row 
					class="customVRow" 
					align="center" 
					justify="center">
				<v-col cols="10" sm="8" md="6">
					<v-card color="transparent" flat>
						<v-card-title>
							<v-row class="my-2" justify="center">
								<v-col cols="auto">
									<span class="h5">Forget Password</span>
								</v-col>
							</v-row>
						</v-card-title>
						<template v-if="!isFalse(errorMessage_)">
							<v-card-text class="cardText_">
								<span class="errorMessage_" v-html="errorMessage_" />
							</v-card-text>
						</template>
						<!-- select sign up option -->
						<template v-if="isEmpty(loginOption_)">
							<v-card-text class="cardText_">
								<v-select
										v-model="loginOption_"
										
										hide-details

										:background-color="$_forgetPassword_styleSelectBackgroundColor"
										:chips="$_forgetPassword_styleSelectChips"
										:clearable="$_forgetPassword_styleSelectClearable"
										:color="$_forgetPassword_styleSelectColor"
										:deletable-chips="$_forgetPassword_styleSelectDeletableChips"
										:dark="$_forgetPassword_styleSelectDark"
										:dense="$_forgetPassword_styleSelectDense"
										:filled="$_forgetPassword_styleSelectFilled"
										:flat="$_forgetPassword_styleSelectFlat"
										:light="$_forgetPassword_styleSelectLight"
										:outlined="$_forgetPassword_styleSelectOutlined"
										:small-chips="$_forgetPassword_styleSelectSmallChips"
										:solo="$_forgetPassword_styleSelectSolo"
										:solo-inverted="$_forgetPassword_styleSelectSoloInverted"

										:placeholder="$_forgetPassword_langSelectLoginOptionPlaceholder"

										:label="$_forgetPassword_langSelectLoginOption"

										item-text="title"
										item-value="key"
										:items="arrayObject(sortObject($_forgetPassword_contentAppLoginOptions, 'order'))" />
							</v-card-text>
							<v-card-actions class="center">
								<v-btn	class="customVBtn"
										:block="$_forgetPassword_styleBackButtonBlock"
										:color="$_forgetPassword_styleBackButtonColor"
										:dark="$_forgetPassword_styleBackButtonDark"
										:depressed="$_forgetPassword_styleBackButtonDepressed"
										:elevation="$_forgetPassword_styleBackButtonElevation"
										:large="$_forgetPassword_styleBackButtonLarge"
										:light="$_forgetPassword_styleBackButtonLight"
										:outlined="$_forgetPassword_styleBackButtonOutlined"
										:rounded="$_forgetPassword_styleBackButtonRounded"
										:small="$_forgetPassword_styleBackButtonSmall"
										:text="$_forgetPassword_styleBackButtonFlat"
										@click="$_forgetPassword_back()"
										v-text="$_forgetPassword_langBackButton" />
							</v-card-actions>
						</template>
						<!-- input field -->
						<template v-else>
							<template v-if="mode_.forget">
								<validation-observer v-slot="validationInput">
									<v-form>
										<v-card-text class="cardText_">
											<template v-if="loginOption_ == 'username'">
												<validation-provider
														name="Username"
														rules="required"
														v-slot="{ errors }">
													<v-text-field
															v-model="form_.username"

															hide-details

															:background-color="$_forgetPassword_styleTextFieldBackgroundColor"
															:clearable="$_forgetPassword_styleTextFieldClearable"
															:color="$_forgetPassword_styleTextFieldColor"
															:counter="$_forgetPassword_styleTextFieldCounter"
															:dark="$_forgetPassword_styleTextFieldDark"
															:filled="$_forgetPassword_styleTextFieldFilled"
															:flat="$_forgetPassword_styleTextFieldFlat"
															:light="$_forgetPassword_styleTextFieldLight"
															:outlined="$_forgetPassword_styleTextFieldOutlined"
															:solo="$_forgetPassword_styleTextFieldSolo"
															:solo-inverted="$_forgetPassword_styleTextFieldSoloInverted"

															:append-icon="$_forgetPassword_styleTextFieldAppendIcon"
															:append-outer-icon="$_forgetPassword_styleTextFieldAppendOuterIcon"
															:prepend-icon="$_forgetPassword_styleTextFieldPrependIcon"
															:prepend-inner-icon="$_forgetPassword_styleTextFieldPrependInnerIcon"

															:hint="$_forgetPassword_langUsernameHint"
															:mask="$_forgetPassword_langUsernameMask"
															:message="$_forgetPassword_langUsernameMessage"
															:placeholder="$_forgetPassword_langUsernamePlaceholder"
															:prefix="$_forgetPassword_langUsernamePrefix"
															:suffix="$_forgetPassword_langUsernameSuffix"
															:type="$_forgetPassword_langUsernameType"

															:label="$_forgetPassword_langUsername"

															:error-messages="errors" />
												</validation-provider>
												<!-- custom for bri life start -->
												<validation-provider
														mode="lazy"
														name="Email address for reset password"
														rules="required|email"
														v-slot="{ errors }">
													<v-text-field
															v-model="formCustomBriLife_.email"

															:background-color="$_forgetPassword_styleTextFieldBackgroundColor"
															:clearable="$_forgetPassword_styleTextFieldClearable"
															:color="$_forgetPassword_styleTextFieldColor"
															:counter="$_forgetPassword_styleTextFieldCounter"
															:dark="$_forgetPassword_styleTextFieldDark"
															:filled="$_forgetPassword_styleTextFieldFilled"
															:flat="$_forgetPassword_styleTextFieldFlat"
															:light="$_forgetPassword_styleTextFieldLight"
															:outlined="$_forgetPassword_styleTextFieldOutlined"
															:solo="$_forgetPassword_styleTextFieldSolo"
															:solo-inverted="$_forgetPassword_styleTextFieldSoloInverted"

															:append-icon="$_forgetPassword_styleTextFieldAppendIcon"
															:append-outer-icon="$_forgetPassword_styleTextFieldAppendOuterIcon"
															:prepend-icon="$_forgetPassword_styleTextFieldPrependIcon"
															:prepend-inner-icon="$_forgetPassword_styleTextFieldPrependInnerIcon"

															:hint="$_forgetPassword_langUsernameHint"
															:mask="$_forgetPassword_langUsernameMask"
															:message="$_forgetPassword_langUsernameMessage"
															:placeholder="$_forgetPassword_langUsernamePlaceholder"
															:prefix="$_forgetPassword_langUsernamePrefix"
															:suffix="$_forgetPassword_langUsernameSuffix"
															:type="$_forgetPassword_langUsernameType"

															label="Your email address?"

															:error-messages="errors" />
												</validation-provider>
												<validation-provider
														mode="lazy"
														name="Phone number for reset password"
														rules="required|phone"
														v-slot="{ errors }">
													<v-text-field
															v-model="formCustomBriLife_.phone"

															:background-color="$_forgetPassword_styleTextFieldBackgroundColor"
															:clearable="$_forgetPassword_styleTextFieldClearable"
															:color="$_forgetPassword_styleTextFieldColor"
															:counter="$_forgetPassword_styleTextFieldCounter"
															:dark="$_forgetPassword_styleTextFieldDark"
															:filled="$_forgetPassword_styleTextFieldFilled"
															:flat="$_forgetPassword_styleTextFieldFlat"
															:light="$_forgetPassword_styleTextFieldLight"
															:outlined="$_forgetPassword_styleTextFieldOutlined"
															:solo="$_forgetPassword_styleTextFieldSolo"
															:solo-inverted="$_forgetPassword_styleTextFieldSoloInverted"

															:append-icon="$_forgetPassword_styleTextFieldAppendIcon"
															:append-outer-icon="$_forgetPassword_styleTextFieldAppendOuterIcon"
															:prepend-icon="$_forgetPassword_styleTextFieldPrependIcon"
															:prepend-inner-icon="$_forgetPassword_styleTextFieldPrependInnerIcon"

															:hint="$_forgetPassword_langUsernameHint"
															:mask="$_forgetPassword_langUsernameMask"
															:message="$_forgetPassword_langUsernameMessage"
															:placeholder="$_forgetPassword_langUsernamePlaceholder"
															:prefix="$_forgetPassword_langUsernamePrefix"
															:suffix="$_forgetPassword_langUsernameSuffix"
															:type="$_forgetPassword_langUsernameType"

															label="Your phone number?"

															:error-messages="errors" />
												</validation-provider>
												<!-- custom for bri life end -->
											</template>
											<template v-if="loginOption_ == 'email'">
												<validation-provider
														name="Email address"
														rules="required|email"
														v-slot="{ errors }">
													<v-text-field
															v-model="form_.email"

															hide-details

															:background-color="$_forgetPassword_styleTextFieldBackgroundColor"
															:clearable="$_forgetPassword_styleTextFieldClearable"
															:color="$_forgetPassword_styleTextFieldColor"
															:counter="$_forgetPassword_styleTextFieldCounter"
															:dark="$_forgetPassword_styleTextFieldDark"
															:filled="$_forgetPassword_styleTextFieldFilled"
															:flat="$_forgetPassword_styleTextFieldFlat"
															:light="$_forgetPassword_styleTextFieldLight"
															:outlined="$_forgetPassword_styleTextFieldOutlined"
															:solo="$_forgetPassword_styleTextFieldSolo"
															:solo-inverted="$_forgetPassword_styleTextFieldSoloInverted"

															:append-icon="$_forgetPassword_styleTextFieldAppendIcon"
															:append-outer-icon="$_forgetPassword_styleTextFieldAppendOuterIcon"
															:prepend-icon="$_forgetPassword_styleTextFieldPrependIcon"
															:prepend-inner-icon="$_forgetPassword_styleTextFieldPrependInnerIcon"

															:hint="$_forgetPassword_langEmailHint"
															:mask="$_forgetPassword_langEmailMask"
															:message="$_forgetPassword_langEmailMessage"
															:placeholder="$_forgetPassword_langEmailPlaceholder"
															:prefix="$_forgetPassword_langEmailPrefix"
															:suffix="$_forgetPassword_langEmailSuffix"
															:type="$_forgetPassword_langEmailType"

															:label="$_forgetPassword_langEmail"

															:error-messages="errors" />
												</validation-provider>
											</template>
											<template v-if="loginOption_ == 'phone'">
												<validation-provider
														name="Phone number"
														rules="required|phone"
														v-slot="{ errors }">
													<v-text-field
															v-model="form_.phone"

															hide-details

															:background-color="$_forgetPassword_styleTextFieldBackgroundColor"
															:clearable="$_forgetPassword_styleTextFieldClearable"
															:color="$_forgetPassword_styleTextFieldColor"
															:counter="$_forgetPassword_styleTextFieldCounter"
															:dark="$_forgetPassword_styleTextFieldDark"
															:filled="$_forgetPassword_styleTextFieldFilled"
															:flat="$_forgetPassword_styleTextFieldFlat"
															:light="$_forgetPassword_styleTextFieldLight"
															:outlined="$_forgetPassword_styleTextFieldOutlined"
															:solo="$_forgetPassword_styleTextFieldSolo"
															:solo-inverted="$_forgetPassword_styleTextFieldSoloInverted"

															:append-icon="$_forgetPassword_styleTextFieldAppendIcon"
															:append-outer-icon="$_forgetPassword_styleTextFieldAppendOuterIcon"
															:prepend-icon="$_forgetPassword_styleTextFieldPrependIcon"
															:prepend-inner-icon="$_forgetPassword_styleTextFieldPrependInnerIcon"

															:hint="$_forgetPassword_langPhoneHint"
															:mask="$_forgetPassword_langPhoneMask"
															:message="$_forgetPassword_langPhoneMessage"
															:placeholder="$_forgetPassword_langPhonePlaceholder"
															:prefix="$_forgetPassword_langPhonePrefix"
															:suffix="$_forgetPassword_langPhoneSuffix"
															:type="$_forgetPassword_langPhoneType"

															:label="$_forgetPassword_langPhone"

															:error-messages="errors" />
												</validation-provider>
											</template>
										</v-card-text>
										<v-card-actions class="center">
											<v-row dense justify="center">
												<!-- reset button -->
												<v-col cols="auto">
													<v-dialog v-model="showDialogReset_" max-width="350px">
														<template v-slot:activator="{ on }">
															<v-btn	class="customVBtn"

																	:disabled="!validationInput.passed && !validationInput.valid"

																	:block="$_forgetPassword_styleResetButtonBlock"
																	:color="$_forgetPassword_styleResetButtonColor"
																	:dark="isEmpty(form_.username) && isEmpty(form_.email) && isEmpty(form_.phone) ? false : $_forgetPassword_styleResetButtonDark"
																	:depressed="$_forgetPassword_styleResetButtonDepressed"
																	:elevation="$_forgetPassword_styleResetButtonElevation"
																	:large="$_forgetPassword_styleResetButtonLarge"
																	:light="$_forgetPassword_styleResetButtonLight"
																	:outlined="$_forgetPassword_styleResetButtonOutlined"
																	:rounded="$_forgetPassword_styleResetButtonRounded"
																	:small="$_forgetPassword_styleResetButtonSmall"
																	:text="$_forgetPassword_styleResetButtonFlat"
																	v-text="$_forgetPassword_langResetButton"
																	v-on="on" />
														</template>
														<v-card class="customVCard px-5 py-2">
															<v-row>
																<v-col>
																	<v-btn	class="customVBtn"
																			block
																			:color="$_forgetPassword_styleRequestButtonColor"
																			:dark="$_forgetPassword_styleRequestButtonDark"
																			:depressed="$_forgetPassword_styleRequestButtonDepressed"
																			:elevation="$_forgetPassword_styleRequestButtonElevation"
																			:large="$_forgetPassword_styleRequestButtonLarge"
																			:light="$_forgetPassword_styleRequestButtonLight"
																			:outlined="$_forgetPassword_styleRequestButtonOutlined"
																			:rounded="$_forgetPassword_styleRequestButtonRounded"
																			:small="$_forgetPassword_styleRequestButtonSmall"
																			:text="$_forgetPassword_styleRequestButtonFlat"
																			@click="$_forgetPassword_reset()">
																		<template v-if="loginOption_ == 'username'">
																			<span v-text="$_forgetPassword_langRequestReset" />
																		</template>
																		<template v-if="loginOption_ == 'email'">
																			<span v-text="$_forgetPassword_langSendEmailLink" />
																		</template>
																		<template v-if="loginOption_ == 'phone'">
																			<span v-text="$_forgetPassword_langSendOtp" />
																		</template>
																	</v-btn>
																</v-col>
															</v-row>
															<v-row>
																<v-col>
																	<v-btn	class="customVBtn"
																			block
																			:color="$_forgetPassword_styleChallengeButtonColor"
																			:dark="$_forgetPassword_styleChallengeButtonDark"
																			:depressed="$_forgetPassword_styleChallengeButtonDepressed"
																			:elevation="$_forgetPassword_styleChallengeButtonElevation"
																			:large="$_forgetPassword_styleChallengeButtonLarge"
																			:light="$_forgetPassword_styleChallengeButtonLight"
																			:outlined="$_forgetPassword_styleChallengeButtonOutlined"
																			:rounded="$_forgetPassword_styleChallengeButtonRounded"
																			:small="$_forgetPassword_styleChallengeButtonSmall"
																			:text="$_forgetPassword_styleChallengeButtonFlat"
																			@click="$_forgetPassword_challenge()"
																			v-text="$_forgetPassword_langChallengeSecurityQuestion" />
																</v-col>
															</v-row>
														</v-card>
													</v-dialog>
												</v-col>
												<!-- cancel button -->
												<v-col cols="auto">
													<v-btn	class="customVBtn"
															:block="$_forgetPassword_styleCancelButtonBlock"
															:color="$_forgetPassword_styleCancelButtonColor"
															:dark="$_forgetPassword_styleCancelButtonDark"
															:depressed="$_forgetPassword_styleCancelButtonDepressed"
															:elevation="$_forgetPassword_styleCancelButtonElevation"
															:large="$_forgetPassword_styleCancelButtonLarge"
															:light="$_forgetPassword_styleCancelButtonLight"
															:outlined="$_forgetPassword_styleCancelButtonOutlined"
															:rounded="$_forgetPassword_styleCancelButtonRounded"
															:small="$_forgetPassword_styleCancelButtonSmall"
															:text="$_forgetPassword_styleCancelButtonFlat"
															@click="$_forgetPassword_cancel()"
															v-text="$_forgetPassword_langCancelButton" />
												</v-col>
											</v-row>
										</v-card-actions>
									</v-form>
								</validation-observer>
							</template>
							<!--  challenge security question -->
							<template v-if="mode_.challenge">
								<validation-observer v-slot="validationChallenge">
									<v-form>
										<v-card-text class="cardText_">
											<template v-for="(securityQuestionVals, securityQuestionKey) in securityQuestions_">
												<template v-if="!isFalse(securityQuestionVals.question)">
													<v-alert
															:key="securityQuestionKey"

															:border="$_forgetPassword_styleAlertBorder"
															:color="$_forgetPassword_styleAlertColor"
															:colored-border="$_forgetPassword_styleAlertColoredBorder"
															:dark="$_forgetPassword_styleAlertDark"
															:dense="$_forgetPassword_styleAlertDense"
															:elevation="$_forgetPassword_styleAlertElevation"
															:light="$_forgetPassword_styleAlertLight"
															:outlined="$_forgetPassword_styleAlertOutlined"
															:prominent="$_forgetPassword_styleAlertProminent"
															:text="$_forgetPassword_styleAlertText"
															:tile="$_forgetPassword_styleAlertTile">
														<v-row dense justify="center">
															<v-col>
																<span v-text="securityQuestionVals.question" />
															</v-col>
														</v-row>
														<v-row dense justify="center">
															<v-col>
																<validation-provider
																		:name="'Answer for ' + securityQuestionKey"
																		rules="required">
																	<v-text-field
																			v-model="formSecurityQuestions_[securityQuestionKey].answer"

																			hide-details

																			:background-color="$_forgetPassword_styleTextFieldChallengeBackgroundColor"
																			:clearable="$_forgetPassword_styleTextFieldChallengeClearable"
																			:color="$_forgetPassword_styleTextFieldChallengeColor"
																			:counter="$_forgetPassword_styleTextFieldChallengeCounter"
																			:dark="$_forgetPassword_styleTextFieldChallengeDark"
																			:filled="$_forgetPassword_styleTextFieldChallengeFilled"
																			:flat="$_forgetPassword_styleTextFieldChallengeFlat"
																			:light="$_forgetPassword_styleTextFieldChallengeLight"
																			:outlined="$_forgetPassword_styleTextFieldChallengeOutlined"
																			:solo="$_forgetPassword_styleTextFieldChallengeSolo"
																			:solo-inverted="$_forgetPassword_styleTextFieldChallengeSoloInverted"

																			type="text"

																			:label="$_forgetPassword_langAnswerQuestion" />
																</validation-provider>
															</v-col>
														</v-row>
													</v-alert>
												</template>
											</template>
										</v-card-text>
										<v-card-actions class="center">
											<v-btn	class="customVBtn"

													:disabled="!validationChallenge.passed && !validationChallenge.valid"

													:block="$_forgetPassword_styleSubmitChallengeButtonBlock"
													:color="$_forgetPassword_styleSubmitChallengeButtonColor"
													:dark="!validationChallenge.passed && !validationChallenge.valid ? $_forgetPassword_stateAppIsDarkTheme : $_forgetPassword_styleSubmitChallengeButtonDark"
													:depressed="$_forgetPassword_styleSubmitChallengeButtonDepressed"
													:elevation="$_forgetPassword_styleSubmitChallengeButtonElevation"
													:large="$_forgetPassword_styleSubmitChallengeButtonLarge"
													:light="$_forgetPassword_styleSubmitChallengeButtonLight"
													:outlined="$_forgetPassword_styleSubmitChallengeButtonOutlined"
													:rounded="$_forgetPassword_styleSubmitChallengeButtonRounded"
													:small="$_forgetPassword_styleSubmitChallengeButtonSmall"
													:text="$_forgetPassword_styleSubmitChallengeButtonFlat"
													@click="$_forgetPassword_submitChallenge()"
													v-text="$_forgetPassword_langSubmitChallengeButton" />
											<v-btn	class="customVBtn"
													:block="$_forgetPassword_styleCancelChallengeButtonBlock"
													:color="$_forgetPassword_styleCancelChallengeButtonColor"
													:dark="$_forgetPassword_styleCancelChallengeButtonDark"
													:depressed="$_forgetPassword_styleCancelChallengeButtonDepressed"
													:elevation="$_forgetPassword_styleCancelChallengeButtonElevation"
													:large="$_forgetPassword_styleCancelChallengeButtonLarge"
													:light="$_forgetPassword_styleCancelChallengeButtonLight"
													:outlined="$_forgetPassword_styleCancelChallengeButtonOutlined"
													:rounded="$_forgetPassword_styleCancelChallengeButtonRounded"
													:small="$_forgetPassword_styleCancelChallengeButtonSmall"
													:text="$_forgetPassword_styleCancelChallengeButtonFlat"
													@click="$_forgetPassword_cancelChallenge()"
													v-text="$_forgetPassword_langCancelChallengeButton" />
										</v-card-actions>
									</v-form>
								</validation-observer>
							</template>
							<!--  reset password (challenge security question was successful) -->
							<template v-if="mode_.resetPassword">
								<validation-observer v-slot="validationResetPassword">
									<v-form>
										<v-card-text class="cardText_">
											<validation-provider
													name="New Password"
													rules="required|min:8"
													mode="lazy"
													v-slot="{ errors }">
												<v-text-field
														v-model="formResetPassword_.newPassword"

														hide-details

														:background-color="$_forgetPassword_styleTextFieldResetPasswordBackgroundColor"
														:clearable="$_forgetPassword_styleTextFieldResetPasswordClearable"
														:color="$_forgetPassword_styleTextFieldResetPasswordColor"
														:counter="$_forgetPassword_styleTextFieldResetPasswordCounter"
														:dark="$_forgetPassword_styleTextFieldResetPasswordDark"
														:filled="$_forgetPassword_styleTextFieldResetPasswordFilled"
														:flat="$_forgetPassword_styleTextFieldResetPasswordFlat"
														:light="$_forgetPassword_styleTextFieldResetPasswordLight"
														:outlined="$_forgetPassword_styleTextFieldResetPasswordOutlined"
														:solo="$_forgetPassword_styleTextFieldResetPasswordSolo"
														:solo-inverted="$_forgetPassword_styleTextFieldResetPasswordSoloInverted"

														:hint="$_forgetPassword_langNewPasswordHint"
														:mask="$_forgetPassword_langNewPasswordMask"
														:message="$_forgetPassword_langNewPasswordMessage"
														:placeholder="$_forgetPassword_langNewPasswordPlaceholder"
														:prefix="$_forgetPassword_langNewPasswordPrefix"
														:suffix="$_forgetPassword_langNewPasswordSuffix"

														:append-icon="showPassword_ ? 'visibility_off' : 'visibility'"
														:type="showPassword_ ? 'text' : 'password'"

														:label="$_forgetPassword_langNewPassword"

														:error-messages="errors"
														@click:append="showPassword_ = !showPassword_" />
											</validation-provider>
											<validation-provider
													name="Confirm password"
													rules="required|min:8"
													v-slot="{ errors }">
												<v-text-field
														v-model="formResetPassword_.confirmPassword"

														hide-details

														:background-color="$_forgetPassword_styleTextFieldResetPasswordBackgroundColor"
														:clearable="$_forgetPassword_styleTextFieldResetPasswordClearable"
														:color="$_forgetPassword_styleTextFieldResetPasswordColor"
														:counter="$_forgetPassword_styleTextFieldResetPasswordCounter"
														:dark="$_forgetPassword_styleTextFieldResetPasswordDark"
														:filled="$_forgetPassword_styleTextFieldResetPasswordFilled"
														:flat="$_forgetPassword_styleTextFieldResetPasswordFlat"
														:light="$_forgetPassword_styleTextFieldResetPasswordLight"
														:outlined="$_forgetPassword_styleTextFieldResetPasswordOutlined"
														:solo="$_forgetPassword_styleTextFieldResetPasswordSolo"
														:solo-inverted="$_forgetPassword_styleTextFieldResetPasswordSoloInverted"

														:hint="$_forgetPassword_langConfirmPasswordHint"
														:mask="$_forgetPassword_langConfirmPasswordMask"
														:message="$_forgetPassword_langConfirmPasswordMessage"
														:placeholder="$_forgetPassword_langConfirmPasswordPlaceholder"
														:prefix="$_forgetPassword_langConfirmPasswordPrefix"
														:suffix="$_forgetPassword_langConfirmPasswordSuffix"

														:append-icon="showPassword_ ? 'visibility_off' : 'visibility'"
														:type="showPassword_ ? 'text' : 'password'"

														:label="$_forgetPassword_langConfirmPassword"

														:error-messages="errors"
														@click:append="showPassword_ = !showPassword_" />
											</validation-provider>
										</v-card-text>
										<v-card-actions class="center">
											<v-btn	class="customVBtn"

													:disabled="!validationResetPassword.passed && !validationResetPassword.valid"

													:block="$_forgetPassword_styleResetPasswordButtonBlock"
													:color="$_forgetPassword_styleResetPasswordButtonColor"
													:dark="!validationResetPassword.passed && !validationResetPassword.valid ? $_forgetPassword_stateAppIsDarkTheme : $_forgetPassword_styleResetPasswordButtonDark"
													:depressed="$_forgetPassword_styleResetPasswordButtonDepressed"
													:elevation="$_forgetPassword_styleResetPasswordButtonElevation"
													:large="$_forgetPassword_styleResetPasswordButtonLarge"
													:light="$_forgetPassword_styleResetPasswordButtonLight"
													:outlined="$_forgetPassword_styleResetPasswordButtonOutlined"
													:rounded="$_forgetPassword_styleResetPasswordButtonRounded"
													:small="$_forgetPassword_styleResetPasswordButtonSmall"
													:text="$_forgetPassword_styleResetPasswordButtonFlat"
													@click="$_forgetPassword_resetPassword()"
													v-text="$_forgetPassword_langResetPasswordButton" />
											<v-btn	class="customVBtn"
													:block="$_forgetPassword_styleCancelResetPasswordButtonBlock"
													:color="$_forgetPassword_styleCancelResetPasswordButtonColor"
													:dark="$_forgetPassword_styleCancelResetPasswordButtonDark"
													:depressed="$_forgetPassword_styleCancelResetPasswordButtonDepressed"
													:elevation="$_forgetPassword_styleCancelResetPasswordButtonElevation"
													:large="$_forgetPassword_styleCancelResetPasswordButtonLarge"
													:light="$_forgetPassword_styleCancelResetPasswordButtonLight"
													:outlined="$_forgetPassword_styleCancelResetPasswordButtonOutlined"
													:rounded="$_forgetPassword_styleCancelResetPasswordButtonRounded"
													:small="$_forgetPassword_styleCancelResetPasswordButtonSmall"
													:text="$_forgetPassword_styleCancelResetPasswordButtonFlat"
													to="/"
													v-text="$_forgetPassword_langCancelResetPasswordButton" />
										</v-card-actions>
									</v-form>
								</validation-observer>
							</template>
							<!--  requested (sign up by username) -->
							<template v-if="mode_.requested">
								<v-card-text class="cardText_ center">
									<span v-html="$_forgetPassword_langRequestedText" />
								</v-card-text>
								<v-card-actions class="center">
									<v-btn	class="customVBtn"
											:block="$_forgetPassword_styleOkButtonBlock"
											:color="$_forgetPassword_styleOkButtonColor"
											:dark="$_forgetPassword_styleOkButtonDark"
											:depressed="$_forgetPassword_styleOkButtonDepressed"
											:elevation="$_forgetPassword_styleOkButtonElevation"
											:large="$_forgetPassword_styleOkButtonLarge"
											:light="$_forgetPassword_styleOkButtonLight"
											:outlined="$_forgetPassword_styleOkButtonOutlined"
											:rounded="$_forgetPassword_styleOkButtonRounded"
											:small="$_forgetPassword_styleOkButtonSmall"
											:text="$_forgetPassword_styleOkButtonFlat"
											@click="openLink($_forgetPassword_linkOkButton)"
											v-text="$_forgetPassword_langOkButton" />
								</v-card-actions>
							</template>
							<!--  emailLink (sign up by email) -->
							<template v-if="mode_.emailLink">
								<v-card-text class="cardText_ center">
									<span v-html="$_forgetPassword_langEmailLinkText" />
								</v-card-text>
								<v-card-actions class="center">
									<v-btn	class="customVBtn"
											:block="$_forgetPassword_styleOkButtonBlock"
											:color="$_forgetPassword_styleOkButtonColor"
											:dark="$_forgetPassword_styleOkButtonDark"
											:depressed="$_forgetPassword_styleOkButtonDepressed"
											:elevation="$_forgetPassword_styleOkButtonElevation"
											:large="$_forgetPassword_styleOkButtonLarge"
											:light="$_forgetPassword_styleOkButtonLight"
											:outlined="$_forgetPassword_styleOkButtonOutlined"
											:rounded="$_forgetPassword_styleOkButtonRounded"
											:small="$_forgetPassword_styleOkButtonSmall"
											:text="$_forgetPassword_styleOkButtonFlat"
											@click="openLink($_forgetPassword_linkOkButton)"
											v-text="$_forgetPassword_langOkButton" />
								</v-card-actions>
							</template>
							<!-- verify otp (sign up by phone) -->
							<template v-if="mode_.otp">
								<validation-observer v-slot="validationOtp">
									<v-form>
										<v-card-text class="cardText_">
											<validation-provider
													name="Otp"
													rules="required|min:6|max:6"
													v-slot="{ errors }">
												<v-text-field
														v-model="form_.otp"

														hide-details

														:background-color="$_forgetPassword_styleTextFieldBackgroundColor"
														:clearable="$_forgetPassword_styleTextFieldClearable"
														:color="$_forgetPassword_styleTextFieldColor"
														:counter="$_forgetPassword_styleTextFieldCounter"
														:dark="$_forgetPassword_styleTextFieldDark"
														:filled="$_forgetPassword_styleTextFieldFilled"
														:flat="$_forgetPassword_styleTextFieldFlat"
														:light="$_forgetPassword_styleTextFieldLight"
														:outlined="$_forgetPassword_styleTextFieldOutlined"
														:solo="$_forgetPassword_styleTextFieldSolo"
														:solo-inverted="$_forgetPassword_styleTextFieldSoloInverted"

														:append-icon="$_forgetPassword_styleTextFieldAppendIcon"
														:append-outer-icon="$_forgetPassword_styleTextFieldAppendOuterIcon"
														:prepend-icon="$_forgetPassword_styleTextFieldPrependIcon"
														:prepend-inner-icon="$_forgetPassword_styleTextFieldPrependInnerIcon"

														:hint="$_forgetPassword_langOtpHint"
														:mask="$_forgetPassword_langOtpMask"
														:message="$_forgetPassword_langOtpMessage"
														:placeholder="$_forgetPassword_langOtpPlaceholder"
														:prefix="$_forgetPassword_langOtpPrefix"
														:suffix="$_forgetPassword_langOtpSuffix"
														:type="$_forgetPassword_langOtpType"

														:label="$_forgetPassword_langOtp"

														:error-messages="errors" />
											</validation-provider>
										</v-card-text>
										<v-card-actions class="center">
											<v-btn	class="customVBtn"

													:disabled="!validationOtp.passed && !validationOtp.valid"

													:block="$_forgetPassword_styleVerifyButtonBlock"
													:color="$_forgetPassword_styleVerifyButtonColor"
													:dark="!validationOtp.passed && !validationOtp.valid ? $_forgetPassword_stateAppIsDarkTheme : $_forgetPassword_styleVerifyButtonDark"
													:depressed="$_forgetPassword_styleVerifyButtonDepressed"
													:elevation="$_forgetPassword_styleVerifyButtonElevation"
													:large="$_forgetPassword_styleVerifyButtonLarge"
													:light="$_forgetPassword_styleVerifyButtonLight"
													:outlined="$_forgetPassword_styleVerifyButtonOutlined"
													:rounded="$_forgetPassword_styleVerifyButtonRounded"
													:small="$_forgetPassword_styleVerifyButtonSmall"
													:text="$_forgetPassword_styleVerifyButtonFlat"
													@click="$_forgetPassword_verifyOtp()"
													v-text="$_forgetPassword_langVerifyButton" />
										</v-card-actions>
									</v-form>
								</validation-observer>
							</template>
						</template>
					</v-card>
				</v-col>
			</v-row>
			<!-- for sending otp -->
			<v-row>
				<v-col id="recaptcha" />
			</v-row>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</v-container>
</template>

<script>
	export default {
		name: 'ForgetPassword',
		data() {
			return {
				// custom for bri life start
				formCustomBriLife_: {
					email: null,
					phone: null
				},
				// custom for bri life end

				pageName_: 'forgetPassword',
				pageType_: 'forgetPassword',
				// initialization
				initialized_: false,
				// login option
				// custom for bri life start
				loginOption_: 'username',
				// custom for bri life end

				// form
				errorMessage_: null,
				form_: {
					username: null,
					email: null,
					phone: null,
					otp: null
				},
				showDialogReset_: false,
				// security question
				securityQuestions_: {
					// question1: { question: text, answer: text },
					// question2: { question: text, answer: text },
					// question3: { question: text, answer: text }
				},
				formSecurityQuestions_: {
					question1: { answer: null },
					question2: { answer: null },
					question3: { answer: null }
				},
				// reset password
				errorMessageResetPassword_: '',
				formResetPassword_: {
					newPassword: null,
					confirmPassword: null
				},
				showPassword_: false,
				// mode
				mode_: {
					forget: true,
					challenge: false,
					requested: false,
					emailLink: false,
					otp: false,
					resetPassword: false
				}
			}
		},
		computed: {
			// current user
			$_forgetPassword_currentUser() {
				const self_ = this;
				return self_.getCurrentUser()
			},
			// state
			$_forgetPassword_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			$_forgetPassword_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			// login options
			$_forgetPassword_contentAppLoginOptions() {
				const self_ = this;
				const contents_ = self_.getAppContents('loginOptions')
				return self_.getContentsSubset(contents_, 'isDummy', false)
			},
			// contents / inits
			$_forgetPassword_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_forgetPassword_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// info
			$_forgetPassword_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.$_forgetPassword_inits(), 'contact')
			},
			// lang
			$_forgetPassword_langBackButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'backButton')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langResetButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'resetButton')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langCancelButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'cancelButton')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langRequestReset() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'requestReset')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langSendEmailLink() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'sendEmailLink')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langSendOtp() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'sendOtp')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langChallengeSecurityQuestion() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'challengeSecurityQuestion')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langAnswerQuestion() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'answerQuestion')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langSubmitChallengeButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'submitChallengeButton')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langCancelChallengeButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'cancelChallengeButton')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langResetPasswordButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'resetPasswordButton')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langCancelResetPasswordButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'cancelResetPasswordButton')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'okButton')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langVerifyButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'verifyButton')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langRequestedText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'requestedText')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langEmailLinkText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'emailLinkText')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langSelectLoginOption() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'selectLoginOption')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langSelectLoginOptionPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'selectLoginOptionPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langUsername() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'username')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langUsernameHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'usernameHint')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langUsernameMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'usernameMask')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langUsernameMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'usernameMessage')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langUsernamePlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'usernamePlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langUsernamePrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'usernamePrefix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langUsernameSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'usernameSuffix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langUsernameType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'usernameType')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langEmail() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'email')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langEmailHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'emailHint')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langEmailMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'emailMask')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langEmailMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'emailMessage')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langEmailPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'emailPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langEmailPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'emailPrefix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langEmailSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'emailSuffix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langEmailType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'emailType')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langPhone() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'phone')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langPhoneHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'phoneHint')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langPhoneMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'phoneMask')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langPhoneMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'phoneMessage')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langPhonePlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'phonePlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langPhonePrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'phonePrefix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langPhoneSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'phoneSuffix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langPhoneType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'phoneType')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langOtp() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'otp')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langOtpHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'otpHint')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langOtpMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'otpMask')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langOtpMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'otpMessage')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langOtpPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'otpPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langOtpPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'otpPrefix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langOtpSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'otpSuffix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langOtpType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'otpType')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langNewPassword() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'newPassword')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langNewPasswordHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'newPasswordHint')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langNewPasswordMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'newPasswordMask')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langNewPasswordMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'newPasswordMessage')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langNewPasswordPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'newPasswordPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langNewPasswordPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'newPasswordPrefix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langNewPasswordSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'newPasswordSuffix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langNewPasswordType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'newPasswordType')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langConfirmPassword() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'confirmPassword')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langConfirmPasswordHint() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'confirmPasswordHint')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langConfirmPasswordMask() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'confirmPasswordMask')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langConfirmPasswordMessage() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'confirmPasswordMessage')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langConfirmPasswordPlaceholder() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'confirmPasswordPlaceholder')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langConfirmPasswordPrefix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'confirmPasswordPrefix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langConfirmPasswordSuffix() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'confirmPasswordSuffix')
				return self_.getLangsVal(lang_)
			},
			$_forgetPassword_langConfirmPasswordType() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_forgetPassword_inits(), 'confirmPasswordType')
				return self_.getLangsVal(lang_)
			},
			// link
			$_forgetPassword_linkOkButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.$_forgetPassword_inits(), 'okButton')
			},
			// style
			$_forgetPassword_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'pageContainer')
			},
			$_forgetPassword_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_forgetPassword_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			},
			$_forgetPassword_styleSelect() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'select')
			},
			$_forgetPassword_styleSelectBackgroundColor() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.backgroundColor)
			},
			$_forgetPassword_styleSelectChips() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.chips)
			},
			$_forgetPassword_styleSelectClearable() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.clearable)
			},
			$_forgetPassword_styleSelectColor() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.color)
			},
			$_forgetPassword_styleSelectDeletableChips() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.deletableChips)
			},
			$_forgetPassword_styleSelectDark() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.dark)
			},
			$_forgetPassword_styleSelectDense() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.dense)
			},
			$_forgetPassword_styleSelectFilled() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.filled)
			},
			$_forgetPassword_styleSelectFlat() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.flat)
			},
			$_forgetPassword_styleSelectLight() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.light)
			},
			$_forgetPassword_styleSelectOutlined() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.outlined)
			},
			$_forgetPassword_styleSelectSmallChips() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.smallChips)
			},
			$_forgetPassword_styleSelectSolo() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.solo)
			},
			$_forgetPassword_styleSelectSoloInverted() {
				const self_ = this;
				const select_ = self_.$_forgetPassword_styleSelect;
				if(self_.isFalse(select_)) { return null }
				return self_.getStylesVal(select_.soloInverted)
			},
			$_forgetPassword_styleTextField() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'textField')
			},
			$_forgetPassword_styleTextFieldAppendIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.appendIcon)
			},
			$_forgetPassword_styleTextFieldAppendOuterIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.appendOuterIcon)
			},
			$_forgetPassword_styleTextFieldBackgroundColor() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.backgroundColor)
			},
			$_forgetPassword_styleTextFieldClearable() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.clearable)
			},
			$_forgetPassword_styleTextFieldColor() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.color)
			},
			$_forgetPassword_styleTextFieldCounter() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.counter)
			},
			$_forgetPassword_styleTextFieldDark() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.dark)
			},
			$_forgetPassword_styleTextFieldFilled() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.filled)
			},
			$_forgetPassword_styleTextFieldFlat() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.flat)
			},
			$_forgetPassword_styleTextFieldLight() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.light)
			},
			$_forgetPassword_styleTextFieldOutlined() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.outlined)
			},
			$_forgetPassword_styleTextFieldPrependIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.prependIcon)
			},
			$_forgetPassword_styleTextFieldPrependInnerIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.prependInnerIcon)
			},
			$_forgetPassword_styleTextFieldSolo() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.solo)
			},
			$_forgetPassword_styleTextFieldSoloInverted() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextField
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.soloInverted)
			},
			$_forgetPassword_styleTextFieldChallenge() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'textFieldChallenge')
			},
			$_forgetPassword_styleTextFieldChallengeAppendIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.appendIcon)
			},
			$_forgetPassword_styleTextFieldChallengeAppendOuterIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.appendOuterIcon)
			},
			$_forgetPassword_styleTextFieldChallengeBackgroundColor() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.backgroundColor)
			},
			$_forgetPassword_styleTextFieldChallengeClearable() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.clearable)
			},
			$_forgetPassword_styleTextFieldChallengeColor() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.color)
			},
			$_forgetPassword_styleTextFieldChallengeCounter() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.counter)
			},
			$_forgetPassword_styleTextFieldChallengeDark() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.dark)
			},
			$_forgetPassword_styleTextFieldChallengeFilled() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.filled)
			},
			$_forgetPassword_styleTextFieldChallengeFlat() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.flat)
			},
			$_forgetPassword_styleTextFieldChallengeLight() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.light)
			},
			$_forgetPassword_styleTextFieldChallengeOutlined() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.outlined)
			},
			$_forgetPassword_styleTextFieldChallengePrependIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.prependIcon)
			},
			$_forgetPassword_styleTextFieldChallengePrependInnerIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.prependInnerIcon)
			},
			$_forgetPassword_styleTextFieldChallengeSolo() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.solo)
			},
			$_forgetPassword_styleTextFieldChallengeSoloInverted() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldChallenge
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.soloInverted)
			},
			$_forgetPassword_styleTextFieldResetPassword() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'textFieldResetPassword')
			},
			$_forgetPassword_styleTextFieldResetPasswordAppendIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.appendIcon)
			},
			$_forgetPassword_styleTextFieldResetPasswordAppendOuterIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.appendOuterIcon)
			},
			$_forgetPassword_styleTextFieldResetPasswordBackgroundColor() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.backgroundColor)
			},
			$_forgetPassword_styleTextFieldResetPasswordClearable() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.clearable)
			},
			$_forgetPassword_styleTextFieldResetPasswordColor() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.color)
			},
			$_forgetPassword_styleTextFieldResetPasswordCounter() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.counter)
			},
			$_forgetPassword_styleTextFieldResetPasswordDark() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.dark)
			},
			$_forgetPassword_styleTextFieldResetPasswordFilled() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.filled)
			},
			$_forgetPassword_styleTextFieldResetPasswordFlat() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.flat)
			},
			$_forgetPassword_styleTextFieldResetPasswordLight() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.light)
			},
			$_forgetPassword_styleTextFieldResetPasswordOutlined() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.outlined)
			},
			$_forgetPassword_styleTextFieldResetPasswordPrependIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.prependIcon)
			},
			$_forgetPassword_styleTextFieldResetPasswordPrependInnerIcon() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword;
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.prependInnerIcon)
			},
			$_forgetPassword_styleTextFieldResetPasswordSolo() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.solo)
			},
			$_forgetPassword_styleTextFieldResetPasswordSoloInverted() {
				const self_ = this;
				const textField_ = self_.$_forgetPassword_styleTextFieldResetPassword
				if(self_.isFalse(textField_)) { return null }
				return self_.getStylesVal(textField_.soloInverted)
			},
			$_forgetPassword_styleBackButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'backButton')
			},
			$_forgetPassword_styleBackButtonBlock() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_forgetPassword_styleBackButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleBackButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleBackButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleBackButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_forgetPassword_styleBackButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleBackButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleBackButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleBackButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleBackButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleBackButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleBackButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_forgetPassword_styleResetButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'resetButton')
			},
			$_forgetPassword_styleResetButtonBlock() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_forgetPassword_styleResetButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleResetButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleResetButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleResetButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_forgetPassword_styleResetButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleResetButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleResetButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleResetButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleResetButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleResetButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_forgetPassword_styleCancelButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'cancelButton')
			},
			$_forgetPassword_styleCancelButtonBlock() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_forgetPassword_styleCancelButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleCancelButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleCancelButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleCancelButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_forgetPassword_styleCancelButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleCancelButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleCancelButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleCancelButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleCancelButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleCancelButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_forgetPassword_styleRequestButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'requestButton')
			},
			$_forgetPassword_styleRequestButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleRequestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleRequestButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleRequestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleRequestButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleRequestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleRequestButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleRequestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_forgetPassword_styleRequestButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleRequestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleRequestButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleRequestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleRequestButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleRequestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleRequestButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleRequestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleRequestButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleRequestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleRequestButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleRequestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_forgetPassword_styleChallengeButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'challengeButton')
			},
			$_forgetPassword_styleChallengeButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleChallengeButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleChallengeButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleChallengeButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_forgetPassword_styleChallengeButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleChallengeButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleChallengeButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleChallengeButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleChallengeButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleChallengeButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_forgetPassword_styleAlert() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'alert')
			},
			$_forgetPassword_styleAlertBorder() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.border)
			},
			$_forgetPassword_styleAlertColor() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.color)
			},
			$_forgetPassword_styleAlertColoredBorder() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.coloredBorder)
			},
			$_forgetPassword_styleAlertDark() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.dark)
			},
			$_forgetPassword_styleAlertDense() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.dense)
			},
			$_forgetPassword_styleAlertElevation() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.elevation)
			},
			$_forgetPassword_styleAlertIcon() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.icon)
			},
			$_forgetPassword_styleAlertLight() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.light)
			},
			$_forgetPassword_styleAlertOutlined() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.outlined)
			},
			$_forgetPassword_styleAlertProminent() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.prominent)
			},
			$_forgetPassword_styleAlertText() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.text)
			},
			$_forgetPassword_styleAlertTile() {
				const self_ = this;
				const alert_ = self_.$_forgetPassword_styleAlert;
				if(self_.isFalse(alert_)) { return null }
				return self_.getStylesVal(alert_.tile)
			},
			$_forgetPassword_styleSubmitChallengeButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'submitChallengeButton')
			},
			$_forgetPassword_styleSubmitChallengeButtonBlock() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_forgetPassword_styleSubmitChallengeButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleSubmitChallengeButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleSubmitChallengeButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleSubmitChallengeButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_forgetPassword_styleSubmitChallengeButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleSubmitChallengeButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleSubmitChallengeButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleSubmitChallengeButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleSubmitChallengeButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleSubmitChallengeButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleSubmitChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_forgetPassword_styleCancelChallengeButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'cancelChallengeButton')
			},
			$_forgetPassword_styleCancelChallengeButtonBlock() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_forgetPassword_styleCancelChallengeButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleCancelChallengeButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleCancelChallengeButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleCancelChallengeButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_forgetPassword_styleCancelChallengeButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleCancelChallengeButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleCancelChallengeButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleCancelChallengeButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleCancelChallengeButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleCancelChallengeButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelChallengeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_forgetPassword_styleResetPasswordButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'resetPasswordButton')
			},
			$_forgetPassword_styleResetPasswordButtonBlock() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_forgetPassword_styleResetPasswordButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleResetPasswordButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleResetPasswordButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleResetPasswordButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleResetPasswordButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleResetPasswordButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleResetPasswordButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleResetPasswordButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleResetPasswordButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleResetPasswordButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_forgetPassword_styleCancelResetPasswordButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'cancelResetPasswordButton')
			},
			$_forgetPassword_styleCancelResetPasswordButtonBlock() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_forgetPassword_styleCancelResetPasswordButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleCancelResetPasswordButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleCancelResetPasswordButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleCancelResetPasswordButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_forgetPassword_styleCancelResetPasswordButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleCancelResetPasswordButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleCancelResetPasswordButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleCancelResetPasswordButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleCancelResetPasswordButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleCancelResetPasswordButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleCancelResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_forgetPassword_styleOkButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'okButton')
			},
			$_forgetPassword_styleOkButtonBlock() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_forgetPassword_styleOkButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleOkButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleOkButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleOkButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_forgetPassword_styleOkButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleOkButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleOkButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleOkButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleOkButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleOkButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleOkButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_forgetPassword_styleVerifyButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_forgetPassword_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_forgetPassword_inits(), 'verifyButton')
			},
			$_forgetPassword_styleVerifyButtonBlock() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_forgetPassword_styleVerifyButtonColor() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_forgetPassword_styleVerifyButtonDark() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_forgetPassword_styleVerifyButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_forgetPassword_styleVerifyButtonElevation() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_forgetPassword_styleVerifyButtonFlat() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_forgetPassword_styleVerifyButtonLarge() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_forgetPassword_styleVerifyButtonLight() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_forgetPassword_styleVerifyButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_forgetPassword_styleVerifyButtonRounded() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_forgetPassword_styleVerifyButtonSmall() {
				const self_ = this;
				const button_ = self_.$_forgetPassword_styleVerifyButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_forgetPassword_setPageState()

			if(self_.$_forgetPassword_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_forgetPassword_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_forgetPassword_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_forgetPassword_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_forgetPassword_initialize()', error)
				})
			},
			$_forgetPassword_reset() {
				const self_ = this;

				let username_ = null;

				if(self_.loginOption_ == 'username') { username_ = self_.form_.username }
				if(self_.loginOption_ == 'email') { username_ = self_.form_.email }
				if(self_.loginOption_ == 'phone') { username_ = '08' + self_.form_.phone }

				Promise.resolve().then(() => {
					if(self_.loginOption_ == 'username') { return self_.$_forgetPassword_resetByUsername() }
					if(self_.loginOption_ == 'email') { return self_.$_forgetPassword_resetByEmail() }
					if(self_.loginOption_ == 'phone') { return self_.$_forgetPassword_resetByPhone() }
				}).then(() => {
					if(self_.loginOption_ == 'username') { self_.mode_ = { requested: true } }
					if(self_.loginOption_ == 'email') { self_.mode_ = { emailLink: true } }
					if(self_.loginOption_ == 'phone') { self_.mode_ = { otp: true } }
				}).catch(error => {
/* error */			self_.logError('Error', '$_forgetPassword_reset()', error)
				})
			},
			$_forgetPassword_resetByUsername() {
				const self_ = this;

				const username_ = self_.form_.username;
				const email_ = 'boid.dev.app+' + self_.appId + '-' + username_ + '@gmail.com';

				const to_ = self_.appId + '@benefit-one.co.id';
				const cc_ = [ 'd.hayashi@benefit-one.co.id', 'dewi@benefit-one.co.id', 'nigel@benefit-one.co.id' ]
				const bcc_ = 'dev@benefit-one.co.id';

				const subject_ = 'Request for resetting password';
				// custom for bri life start
				const html_ = `
					Please reset password.<br>
					<br>
					Username: ` + username_ + `<br>
					Email: ` + self_.formCustomBriLife_.email + `<br>
					Phone: ` + self_.formCustomBriLife_.phone + `<br>
					<br>
					App ID: ` + self_.appId + `<br>
					App Name: ` + self_.appName + `<br>
					App Version: ` + self_.appVersion + `<br>
				`
				// custom for bri life end

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
					// custom for bri life start
						return self_.customBriLifeUpdateUser(username_, self_.formCustomBriLife_.email, self_.formCustomBriLife_.phone)
					}).then(() => {
					// custom for bri life end
						return self_.sendGridPost(to_, cc_, bcc_, subject_, html_)
					}).then(() => {
						resolve()
					}).catch(error => {
						let error_
						if(self_.isFalse(error)) {
							error_ = 'Error: requestResetPasswordByEmail(' + username_ + ', ' + email_ + ') -> promise';
						} else { error_ = error }
						reject(error_)
					})
				})
			},
			$_forgetPassword_resetByEmail() {
				const self_ = this;

				window.localStorage.setItem('modeOfAuth', 'forgetPassword')	
				window.localStorage.setItem('emailForAuth', self_.form_.email)

				return self_.sendEmailLink()
			},
			$_forgetPassword_resetByPhone() {
				const self_ = this;

				let phone_ = null;

				if(self_.form_.phone.substr(0, 4) == 'test') {
					phone_ = '+1650555' + self_.form_.phone.substr(4, 4);
				} else if(self_.form_.phone == 'admin') {
					phone_ = '+16505550000';
				} else {
					phone_ = '+628' + self_.form_.phone;
				}

				return self_.sendOtp(phone_)
			},
			$_forgetPassword_verifyOtp(){
				const self_ = this;
				const router_ = self_.$router;

				Promise.resolve().then(() => {
					const otp_ = self_.form_.otp;
					return self_.verifyOtp(otp_)
				}).then(() => {
					router_.push('/reset-password')
				}).catch(error => {
/* error */			self_.logError('Error', '$_forgetPassword_verifyOtp()', error)
				})
			},
			$_forgetPassword_challenge() {
				const self_ = this;

				Promise.resolve().then(() => {
					let username_ = null;
					if(self_.loginOption_ == 'username') { username_ = self_.form_.username; }
					if(self_.loginOption_ == 'email') { username_ = self_.form_.email; }
					if(self_.loginOption_ == 'phone') {
						if(self_.form_.phone.substr(0,4) == 'test' || self_.form_.phone == 'admin') {
							username_ = self_.form_.phone;
						} else {
							username_ = '08' + self_.form_.phone;
						}
					}
					return self_.getUserByUsername(username_)
				}).then(result => {
					return self_.ipCliGetAppUserSecurityQuestions({ uid: result.uid })
				}).then(result => {
					if(self_.isEmpty(result)) {
						self_.errorMessage_ = 'Security question is not set.';
						self_.showDialogReset_ = false;
					} else {
						self_.securityQuestions_ = result;
						self_.showDialogReset_ = false;
						self_.mode_ = { challenge: true }
					}
				}).catch(error => {
/* error */			self_.logError('Error', '$_forgetPassword_challenge()', error)
				})
			},
			$_forgetPassword_submitChallenge() {
				const self_ = this;

				const answer1_ = self_.isFalse(self_.securityQuestions_.question1.answer) || self_.securityQuestions_.question1.answer == self_.formSecurityQuestions_.question1.answer;
				const answer2_ = self_.isFalse(self_.securityQuestions_.question2.answer) || self_.securityQuestions_.question2.answer == self_.formSecurityQuestions_.question2.answer;
				const answer3_ = self_.isFalse(self_.securityQuestions_.question3.answer) || self_.securityQuestions_.question3.answer == self_.formSecurityQuestions_.question3.answer;
				if(answer1_ && answer2_ && answer3_) { self_.mode_ = { resetPassword: true }}
				else {
					self_.errorMessage_ = 'Wrong answer for security question.'
					self_.mode_ = { forget: true }
				}
			},
			$_forgetPassword_cancelChallenge() {
				const self_ = this;
				self_.mode_ = { forget: true }
			},
			$_forgetPassword_resetPassword() {
				const self_ = this;

				if(self_.formResetPassword_.newPassword != self_.formResetPassword_.confirmPassword) {
					self_.errorMessageResetPassword_ = 'Password does not match.';
					return
				}

				Promise.resolve().then(() => {
					let username_ = null;
					if(self_.loginOption_ == 'username') { username_ = self_.form_.username; }
					if(self_.loginOption_ == 'email') { username_ = self_.form_.email; }
					if(self_.loginOption_ == 'phone') {
						if(self_.form_.phone.substr(0, 4) == 'test' || self_.form_.phone == 'admin') {
							username_ = self_.form_.phone;
						} else {
							username_ = '08' + self_.form_.phone;
						}
					}
					return self_.getUserByUsername(username_)
				}).then(result => {
					const uid_ = result.uid;
					const password_ = self_.formResetPassword_.newPassword;
					return self_.resetPassword(uid_, password_)
				}).then(() => {
					self_.logout()
				}).catch(error => {
/* error */			self_.logError('Error', '$_forgetPassword_resetPassword()', error)
				})

			},
			$_forgetPassword_cancel(){
				const self_ = this;

				// custom for bri life start
				self_.$router.replace('/login')
				// custom for bri life end

				self_.loginOption_ = '';

				self_.mode_ = {
					forget: true,
					challenge: false,
					requested: false,
					emailLink: false,
					otp: false,
					resetPassword: false
				}
			},
			$_forgetPassword_back() {
				const self_ = this;
				const router_ = self_.$router;

				router_.replace('/login')
			}
		}
	}
</script>

<style scoped>
	.errorMessage_ {
		color: red;
	}
	.cardText_ {
		padding-top: 0 !important;
	}
</style>